import { Box, Button, Stack, Typography } from "@mui/material";
import JobSeekerCard from "./JobSeekerCard";
import { Masonry } from "@mui/lab";
import SectionHeadingButton from "./SectionHeadingButton";

const rightCardsData = [
  {
    nmbr: "01",
    text: { one: "Extensive", second: "Job Listings" },
    description:
      "We have a large and constantly updated database of job listings from top employers across a range of industries.",
    minWidth: true,
  },
  {
    nmbr: "02",
    text: { one: "Easy", second: "Job Search" },
    description:
      "Our platform is designed to make your job search as simple and efficient as possible, with powerful search tools and filters.",
    dividerTop: true,
    minWidth: true,
  },
  {
    nmbr: "03",
    text: { one: "User", second: "Friendly" },
    description:
      "Our user-friendly interface is designed to provide a seamless experience for job seekers and employers with easy tools.",
    minWidth: true,
  },
  {
    nmbr: "04",
    text: { one: "Mobile", second: "Compatibility" },
    description:
      "We have a large and constantly updated database of job listings from top employers across a range of industries.",
    minWidth: true,
  },
];
function WeHelpJobSeekersSection() {
  return (
    <Stack
      direction="row"
      sx={{
        my: "140px",
        mx: "90px",
        gap: "50px",
        position: "relative",
        justifyContent: "center",
      }}
    >
      <Box
        component="img"
        src="/icons/readyToTakePlusIcon.svg"
        sx={{
          width: 40,
          height: 40,
          position: "absolute",
          bottom: 0,
          left: 0,
        }}
      ></Box>
      {/* <Stack
        id="left-4-Cards"
        direction="row"
        sx={{
          //   gap: "14px",
          flexWrap: "wrap",
          width: "50%",
          alignItems: "start",
          justifyContent: "center",
        }}
      >
        {rightCardsData.map((suggestion, index) => (
          <JobSeekerCard
            nmbr={suggestion.nmbr}
            text={suggestion.text}
            description={suggestion.description}
            marginTop={suggestion.marginTop}
          />
        ))}
      </Stack> */}
      <Masonry columns={1} spacing={2.5} sx={{ width: "50%" }}>
        {rightCardsData.map((suggestion, index) => (
          <JobSeekerCard
            nmbr={suggestion.nmbr}
            text={suggestion.text}
            description={suggestion.description}
            dividerTop={suggestion.dividerTop}
            minWidth={suggestion.minWidth}
          />
        ))}
      </Masonry>
      <Stack id="right-cards" sx={{ width: "50%", position: "relative" }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: "54px",
            fontWeight: "",
            lineHeight: "70px",
            width: "540px",
            pl: "30px",
          }}
        >
          We help <strong> job seekers </strong> and{" "}
          <strong> employers </strong>
          find their true perfect match.
          <Box
            component="img"
            src="/icons/readyToTakePlusIcon.svg"
            sx={{
              width: 40,
              height: 40,
              position: "absolute",
              top: 0,
              left: 600,
            }}
          ></Box>
        </Typography>
        <Stack
          direction="row"
          sx={{
            // flexWrap: "wrap",
            // alignItems: "center",
            // justifyContent: "space-between",
            gap: "20px",
            pt: "40px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "40px" }}>
            <JobSeekerCard
              nmbr="05"
              text={{ one: "Customer", second: "Support" }}
              description="Our dedicated customer support team is always available to help you with any questions or concerns you may have."
            />
            <SectionHeadingButton>Learn More About us</SectionHeadingButton>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "40px" }}>
            <Typography
              sx={{
                fontSize: "18px",
                lineHeight: "26px",
                fontFamily: "Inter",
                fontWeight: "400",
                color: "#0E0B33",
                maxWidth: "220px",
                display: "flex",
                flexDirection: "column",
                height: "max-content",
                pl: "30px",
              }}
            >
              Here is why our services are top notch than other job portal
              services.
              <br />
              <span style={{ marginTop: "20px" }}>Let us help you.</span>
            </Typography>
            <JobSeekerCard
              nmbr="06"
              text={{ one: "Job", second: "Recommendation" }}
              description="We use advanced algorithms to analyze your job search activity and provide personalized job recommendations."
            />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default WeHelpJobSeekersSection;
